import { memo } from 'react';
import GenericIcon from './GenericIcon';

export default memo((params) => (
  <GenericIcon {...params}>
    <path d="M20 13L16 17M16 13L20 17L16 13Z" />
    <path d="M20 5H13L9 19L6 13H4" />
  </GenericIcon>
));
